import { defineStore } from 'pinia'

export const useNotifyStore = defineStore('notify', {
  state: () => ({
    options: null,
    timestamp: 0,
  }),

  actions: {
    show(options) {
      this.options = options
      this.timestamp = Date.now()
    },
  },
})